import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import Moment from 'react-moment';
import { Button, Card, Col, Form as BootstrapForm, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import {
  faCircleE, faCircleI, faCircleU, faCircleV, faPencil, faUserUnlock
} from '@fortawesome/pro-solid-svg-icons';
import { Field, Formik } from "formik";
import * as Yup from 'yup';
import Scrollbar from '../components/Scrollbars';
import Header from '../components/Header';
import { TextInput } from '../components/Form';
import { SystemErrorContext } from '../components/SystemError';
import LoadingLink from '../components/LoadingLink';
import { AuthContext } from "../accounts/AccountsReducer";
import ActionsDropdown from '../components/ActionsDropdown';

function UserProfile({ id, incident, organization }) {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(false);

  const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

  const [showUserResetConfirm, setShowUserResetConfirm] = useState(false);
  const handleUserResetClose = () => setShowUserResetConfirm(false);
  const [showChangeEmail, setShowChangeEmail] = useState(false);
  const handleChangeEmailClose = () => setShowChangeEmail(false);

  const newEmailRef = useRef(null);

  const [newEmailData, setNewEmailData] = useState({id:id, new_email:'', org_slug:organization});
  const [showEditModal, setShowEditModal] = useState(false);
  const handleCloseEditModal = () => {setShowEditModal(false);};

  // Initial user data.
  const [data, setData] = useState({
    id: id,
    organization: state.organization.id,
    org_names: state.user.org_names.join(", ") || '',
    first_name: state.user.first_name || '',
    last_name: state.user.last_name || '',
    cell_phone: state.user.cell_phone || '',
    display_phone: state.user.display_phone || '',
    email: state.user.email || '',
    agency_id: state.user.agency_id || '',
    incident_perms: state.user.incident_perms || false,
    user_perms: state.user.user_perms || false,
    vet_perms: state.user.vet_perms || false,
  });

  const handleResetUserSubmit = async () => {
    await axios.patch('/accounts/api/user/' + id + '/', {'reset_password':true, 'organization': state.organization.id})
    .then(response => {
      handleUserResetClose();
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  return (
    <>
    <Header><span id="back" style={{cursor:'pointer'}} onClick={() => state.prevLocation ? navigate(state.prevLocation) : navigate('/' + organization + '/' + incident)} className="mr-3"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" inverse /></span>User Profile</Header>
    <hr/>
    <div className="row">
      <div className="col-10 d-flex" style={{marginRight:"-15px"}}>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px", marginBottom:"-6px"}}>
            <div className="d-flex justify-content-between">
              <h4 className="h5 pt-2" style={{marginBottom:"10px"}}>Information
              </h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center mr-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown alignRight={true} variant="dark" title="Actions">
                    <LoadingLink
                        isLoading={false}
                        className="text-white d-block py-1 px-3"
                        onClick={() => {setShowEditModal(true);}}
                    >
                        <FontAwesomeIcon icon={faPencil} className="mr-1" style={{marginLeft:"-1px"}}  inverse />
                        Edit User Profile
                    </LoadingLink>
                    <LoadingLink
                        isLoading={false}
                        className="text-white d-block py-1 px-3"
                        onClick={() => {setShowUserResetConfirm(true);}}
                    >
                        <FontAwesomeIcon icon={faUserUnlock} className="mr-1" style={{marginLeft:"-4px"}} inverse />
                        Reset Password
                    </LoadingLink>
                    <LoadingLink
                        isLoading={false}
                        className="text-white d-block py-1 px-3"
                        onClick={() => {setShowChangeEmail(true);setTimeout(()=>{newEmailRef.current && newEmailRef.current.focus()}, 1);}}
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="mr-1" inverse />
                        Change Email
                    </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <hr className="pt-0 mt-1" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>First Name:</b> {data.first_name}</span>
                  <span className="col-6"><b>Last Name:</b> {data.last_name}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Phone:</b> {data.display_phone}</span>
                  <span className="col-6"><b>Agency ID:</b> {data.agency_id || 'N/A'}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Email:</b> {data.email}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Permissions: </b>
                    {data.user_perms ? <OverlayTrigger
                        key={"user-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-user-perms`}>
                            User has user permissions
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleU} size="lg" className="ml-1" />
                        </OverlayTrigger> : ""}
                        {data.incident_perms ? <OverlayTrigger
                        key={"incident-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-incident-perms`}>
                            User has incident permissions
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleI} size="lg" className="ml-1" />
                        </OverlayTrigger> : ""}
                        {data.vet_perms ? <OverlayTrigger
                        key={"vet-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-vet-perms`}>
                            User has veterinary permissions
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleV} size="lg" className="ml-1" />
                    </OverlayTrigger> : ""}
                    {!data.user_perms && !data.incident_perms && !data.vet_perms ? "None" : ""}
                  </span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <span><b>Organizations: </b> {data.org_names || "None"}</span>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>{state.organization.name} Access Expires:</b> {state.user.access_expires_at ? <Moment format="LL">{state.user.access_expires_at}</Moment> : "Never"}</span>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </div>
    <Modal show={showUserResetConfirm} onHide={handleUserResetClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm User Password Reset</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to initialize a password reset?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleResetUserSubmit}>Send Password Reset Email</Button>
        <Button variant="secondary" onClick={handleUserResetClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Formik
      initialValues={newEmailData}
      enableReinitialize={true}
      validationSchema={Yup.object({
        id: Yup.string().required(),
        new_email: Yup.string().required('Please enter a valid email address.')
          .max(50, 'Must be 50 characters or less')
          .email('Please enter a valid email address.'),
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        // Send verification email.
        axios.get('/accounts/api/user/' + id + '/email_verification/', {params:values})
        .then(response => {
          resetForm();
          setNewEmailData({id:id, new_email:'', org_slug:organization});
          setShowChangeEmail(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
    {formikProps => (
      <Modal show={showChangeEmail} onHide={handleChangeEmailClose} aria-modal="true">
        <Modal.Header closeButton>
          <Modal.Title>Change Email Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Changing your email address will require your verification before Shelterly uses your new email address.</p>
          <BootstrapForm.Row className="mt-3">
            <TextInput
              rows={5}
              label="New Email Address"
              name="new_email"
              id="new_email"
              xs="12"
              ref={newEmailRef}
            />
          </BootstrapForm.Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Send Verification Email</Button>
          <Button variant="secondary" onClick={handleChangeEmailClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )}
    </Formik>
    <Formik
      initialValues={data}
      enableReinitialize={true}
      validationSchema={Yup.object({
        first_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        last_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        // email: Yup.string()
        //   .max(50, 'Must be 50 characters or less')
        //   .required('Required'),
        cell_phone: Yup.string().required('Required').matches(phoneRegex, "Phone number is not valid").min(10, "Phone number is not valid"),
        agency_id: Yup.string().nullable()
          .max(50, 'Must be 50 characters or less'),
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        axios.patch('/accounts/api/user/' + data.id + '/', values)
        .then(response => {
          setData(response.data);
          dispatch({type: 'USER_LOADED', user: response.data });
          setShowEditModal(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
    {formikProps => (
    <Modal show={showEditModal} onHide={handleCloseEditModal} aria-modal="true">
      <Modal.Header closeButton>
        <Modal.Title>Edit User Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BootstrapForm.Row>
          <TextInput
            type="text"
            label="First Name*"
            name="first_name"
            id="first_name"
            xs="6"
          />
          <TextInput
            type="text"
            label="Last Name*"
            name="last_name"
            id="last_name"
            xs="6"
          />
        </BootstrapForm.Row>
        <BootstrapForm.Row>
          <TextInput
            type="text"
            label="Phone*"
            name="cell_phone"
            id="cell_phone"
            xs="6"
            value={formikProps.values.cell_phone || ''}
          />
          <TextInput
            type="text"
            label="Agency ID"
            name="agency_id"
            id="agency_id"
            xs="6"
            value={formikProps.values.agency_id || ''}
          />
        </BootstrapForm.Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
        <Button variant="secondary" onClick={handleCloseEditModal}>Close</Button>
      </Modal.Footer>
    </Modal>
    )}
    </Formik>
    </>
  );
};

export default UserProfile;
